"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSegmentWidths = exports.initSegments = exports.formatData = exports.parseMetrics = void 0;
const lodash_1 = __importDefault(require("lodash"));
const colors_1 = require("../../utilities/colors");
const constants_1 = require("./constants");
function parseMetrics(rawMetrics, _ref) {
  let {
    color,
    negativeColor
  } = _ref;
  return rawMetrics.map(rm => ({
    id: rm.id,
    color: (0, colors_1.parseColor)(rm.color || color, colors_1.DEFAULT_COLORS[0]),
    negativeColor: (0, colors_1.parseColor)(rm.negativeColor || negativeColor, colors_1.DEFAULT_COLORS[1]),
    featured: Boolean(rm.featured),
    labelText: rm.labelText,
    tooltipTitle: rm.tooltipTitle
  }));
}
exports.parseMetrics = parseMetrics;
function formatData(data, selectedKey) {
  let featuredPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let sort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  let barData = (0, lodash_1.default)(data).map(d => ({
    ...d,
    data: lodash_1.default.find(d.data, {
      key: selectedKey
    })
  }));
  if (sort) {
    barData = barData.orderBy([i => lodash_1.default.get(i, 'data.value', 0)], [sort === 'ascending' ? 'asc' : 'desc']);
  }
  if (featuredPosition) {
    barData = barData.orderBy([i => i.metric.featured], [featuredPosition === 'bottom' ? 'asc' : 'desc']);
  }
  return barData.value();
}
exports.formatData = formatData;
function initSegments(_ref2) {
  let {
    barFontSize,
    barHeight,
    barSpacing,
    data,
    initialY = 0,
    textColor
  } = _ref2;
  const segments = [];
  const spacers = [];
  data.forEach((_ref3, i, dataArr) => {
    let {
      id,
      name,
      data,
      metric: {
        color,
        negativeColor,
        featured
      }
    } = _ref3;
    const isPositive = data && data.value > 0;
    const style = {
      fill: textColor,
      opacity: constants_1.DEFAULT_LABEL_OPACITY,
      fontSize: barFontSize,
      fontWeight: constants_1.DEFAULT_LABEL_FONT_WEIGHT
    };
    let y = i * (barHeight + barSpacing) + spacers.length * (constants_1.DEFAULT_FEATURED_BAR_SPACER_HEIGHT + barSpacing) + initialY;
    if (i > 0 && dataArr[i - 1].metric.featured !== featured) {
      spacers.push({
        height: constants_1.DEFAULT_FEATURED_BAR_SPACER_HEIGHT,
        color: constants_1.DEFAULT_FEATURED_BAR_SPACER_COLOR,
        y
      });
      y += constants_1.DEFAULT_FEATURED_BAR_SPACER_HEIGHT + barSpacing;
    }
    const labelY = y + barHeight / 2 + barFontSize / 4;
    segments.push({
      data: dataArr[i],
      label: {
        key: id,
        content: name,
        y: labelY,
        style
      },
      bar: {
        key: id,
        height: barHeight,
        color: isPositive ? color : negativeColor,
        y
      },
      value: {
        key: id,
        content: data ? data.value : null,
        y: labelY,
        style
      }
    });
  });
  return {
    segments,
    spacers
  };
}
exports.initSegments = initSegments;
function updateSegmentWidths(_ref4) {
  let {
    segments: oldSegments,
    spacers: oldSpacers,
    xScale,
    chartWidth,
    maxValueWidth,
    valuesCrossZero,
    valuesAllNegative
  } = _ref4;
  const zeroLineX = valuesCrossZero ? xScale(0) : 0;
  const spacers = oldSpacers.map(spacer => ({
    ...spacer,
    width: chartWidth,
    x: 0
  }));
  const segments = oldSegments.map(segment => {
    let barWidth = 0;
    let barX = xScale.range()[0];
    let labelX = xScale.range()[0] + constants_1.DEFAULT_LABEL_PADDING;
    if (segment.data.data) {
      const {
        value
      } = segment.data.data;
      const width = xScale(value);
      const isPositive = value > 0;
      barWidth = width - zeroLineX - xScale.range()[0];
      labelX += barWidth;
      if (valuesAllNegative) {
        barWidth = width - zeroLineX - xScale.range()[1];
        [, barX] = xScale.range();
        labelX = xScale.range()[1] - Math.abs(barWidth) - constants_1.DEFAULT_LABEL_PADDING - maxValueWidth;
      } else if (valuesCrossZero) {
        barWidth = width - zeroLineX;
        barX = zeroLineX;
        if (isPositive) {
          labelX = zeroLineX + Math.abs(barWidth) + constants_1.DEFAULT_LABEL_PADDING;
        } else {
          labelX = zeroLineX - Math.abs(barWidth) - constants_1.DEFAULT_LABEL_PADDING - maxValueWidth;
        }
      }
    }
    return {
      label: {
        ...segment.label,
        x: 0
      },
      bar: {
        ...segment.bar,
        width: barWidth,
        x: barX
      },
      value: {
        ...segment.value,
        x: labelX
      }
    };
  });
  return {
    spacers,
    segments
  };
}
exports.updateSegmentWidths = updateSegmentWidths;